module.exports = __webpack_public_path__ + "static/media/lock-login.c978c0e9.svg";